import Form                                     from "@/utils/forms/form";
import baseField                                from "@/utils/forms/fields/baseField";
import { isCreditCardNumber, isExpirationDate } from "@/utils/forms/validators";
import BaseForm                                 from "@/utils/BaseForm";

class CardFormValidator extends Form {
    constructor(data) {
        super(data);
        this.number = new baseField({
            label: "Credit card number",
            validators: [isCreditCardNumber],
            zeroValues: [""]
        });
        this.validThrough = new baseField({
            label: "Valid through",
            validators: [isExpirationDate],
            zeroValues: [""]
        });
    }
}

export default class CardForm extends BaseForm {
    constructor() {
        super(CardFormValidator);
        this.number = "";
        this.validThrough = "";
    }

    setNumber(e) {
        const val = e.target.value.replace(/\s/g, "");
        if ((val.length > 0 && !/^\d+$/g.test(val)) || val.length > 16) {
            e.target.value = this.number;
            return;
        }
        this.number = val;
    }

    setValidThrough(e) {
        const val = e.target.value.replace(/\s/g, "");
        if ((val.length > 0 && /[^\d/]/g.test(val)) || val.length > 7) {
            e.target.value = this.validThrough;
            return;
        }
        this.validThrough = val;
    }
}